import { DOCUMENT } from '@angular/common';
import * as i0 from '@angular/core';
import { Component, ViewEncapsulation, ChangeDetectionStrategy, inject, DestroyRef, Directive, Input } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { tuiTypedFromEvent } from '@taiga-ui/cdk/observables';
import { tuiIsHTMLElement } from '@taiga-ui/cdk/utils/dom';
import { tuiWithStyles, tuiPx } from '@taiga-ui/cdk/utils/miscellaneous';
import { TUI_ANIMATIONS_SPEED } from '@taiga-ui/core/tokens';
import { tuiGetDuration } from '@taiga-ui/core/utils/miscellaneous';
import { merge, race, switchMap, first, tap } from 'rxjs';
const TO_KEYFRAMES = [{
  transform: 'scale(0)',
  opacity: '0.12'
}, {
  opacity: '0.12'
}];
const FROM_KEYFRAMES = [{
  opacity: '0.12'
}, {
  opacity: '0'
}];
let TuiRippleStyles = /*#__PURE__*/(() => {
  class TuiRippleStyles {
    static {
      this.ɵfac = function TuiRippleStyles_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TuiRippleStyles)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: TuiRippleStyles,
        selectors: [["ng-component"]],
        hostAttrs: [1, "tui-ripple-styles"],
        decls: 0,
        vars: 0,
        template: function TuiRippleStyles_Template(rf, ctx) {},
        styles: [".tui-ripple{position:absolute;z-index:100;opacity:.12;border-radius:100%;background:var(--tui-ripple-background, currentColor);animation-fill-mode:forwards;pointer-events:none}\n"],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return TuiRippleStyles;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TuiRipple = /*#__PURE__*/(() => {
  class TuiRipple {
    constructor() {
      this.document = inject(DOCUMENT);
      this.destroyRef = inject(DestroyRef);
      this.animationOptions = {
        duration: tuiGetDuration(inject(TUI_ANIMATIONS_SPEED))
      };
      this.nothing = tuiWithStyles(TuiRippleStyles);
      this.tuiRipple = '';
    }
    start(x, y, target, el) {
      const element = this.tuiRipple ? target.closest(this.tuiRipple) : el;
      if (!tuiIsHTMLElement(element)) {
        return;
      }
      const ripple = this.createRipple(x, y, element.getBoundingClientRect());
      const touchEnd$ = merge(tuiTypedFromEvent(element, 'pointerup'), tuiTypedFromEvent(element, 'pointercancel'), tuiTypedFromEvent(element, 'pointermove'));
      element.appendChild(ripple);
      const animationEndOn$ = tuiTypedFromEvent(ripple.animate(TO_KEYFRAMES, this.animationOptions), 'finish');
      race(touchEnd$.pipe(switchMap(() => animationEndOn$)), animationEndOn$.pipe(switchMap(() => touchEnd$))).pipe(first(), switchMap(() => tuiTypedFromEvent(ripple.animate(FROM_KEYFRAMES, this.animationOptions), 'finish')), first(), tap(() => element.removeChild(ripple)), takeUntilDestroyed(this.destroyRef)).subscribe();
    }
    createRipple(clientX, clientY, {
      width,
      height,
      top,
      left
    }) {
      const ripple = this.document.createElement('div');
      const radius = Math.sqrt(width * width + height * height);
      const dimension = radius * 2;
      const x = clientX - left - radius;
      const y = clientY - top - radius;
      Object.assign(ripple.style, {
        position: 'absolute',
        top: tuiPx(y),
        left: tuiPx(x),
        width: tuiPx(dimension),
        height: tuiPx(dimension),
        zIndex: 100,
        opacity: 0.12,
        borderRadius: '100%',
        background: 'var(--tui-ripple-background, currentColor)',
        animationFillMode: 'forwards',
        pointerEvents: 'none'
      });
      return ripple;
    }
    static {
      this.ɵfac = function TuiRipple_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TuiRipple)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: TuiRipple,
        selectors: [["", "tuiRipple", ""]],
        hostBindings: function TuiRipple_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("pointerdown.zoneless", function TuiRipple_pointerdown_zoneless_HostBindingHandler($event) {
              return ctx.start($event.clientX, $event.clientY, $event.target, $event.currentTarget);
            });
          }
        },
        inputs: {
          tuiRipple: "tuiRipple"
        }
      });
    }
  }
  return TuiRipple;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { TuiRipple };
